import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuBar from './common/MenuBar';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import { loadRxDetails, getAttachmentPath, unlockRXDetails, getOpenOrdersFile } from '../Services/loadOrder';
import Box from '@mui/material/Box';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import '../assets/css/home.css';
import NeedsTrackingModal from './common/NeedsTrackingModal';
import { Toaster, toast } from 'react-hot-toast';

const DispensedCignaOpenOrder = () => {
  const { state = {} } = useLocation();
  const navigate = useNavigate();

  const [taskDetail, setTaskDetail] = useState(null);
  const [gridRows, setGridRows] = useState([]);
  const [totalAmount, setTotalAmount] = useState('0.00');
  const [shippingCarrier, setShippingCarrier] = useState('');
  const [trackingNumber, setTrackingNumber] = useState('');
  const [Prescriptions, setPrescriptions] = useState([]);
  const [shipping, setShipping] = useState({});
  const [documents, setDocuments] = useState([]);
  const [attachmentUrls, setAttachmentUrls] = useState([]);
  const [notes, setNotes] = useState('');
  const [notesBoxActive, setNotesBoxActive] = useState(false);
  const [medicalAuth, setMedicalAuth] = useState('');
  

  const { taskId, contract, pharmacyId, userId } = state;

  useEffect(() => {
    const fetchRx = async () => {
      try {
        const result = await loadRxDetails(taskId, contract, pharmacyId, userId);
        const data = result?.data || {};

        const task = data.TaskDetail[0] || data.TaskDetail ; 
        const shippingInfo = data.ShippingInfos[0] || data.ShippingInfos;
        const prescriptions = data.Prescriptions || [];
        const document = data.Documents || [];
        console.log('this is the document data', document);

        // documents defining attachmentUrls
         const fetchUrls = async () => {
                    let urls = await Promise.all(
                        document.map(doc => {
                           console.log('Calling getAttachmentPath with:', doc?.Path)
                        return  getAttachmentPath(doc?.Path)})
                      );
                      console.log("Fetched attachment URLs:", urls);
                      setAttachmentUrls(urls);}
                      fetchUrls();

        setTaskDetail(task);
        setShipping(shippingInfo);
        setShippingCarrier(shippingInfo.ShippingCarrier || '');
        setTrackingNumber(shippingInfo.TrackingNo || '');
        setPrescriptions(prescriptions);
        setDocuments(document);

        // console.log('This is the prescription object', prescriptions);

        

        const rows = prescriptions.map((p, i) => {
         
          const baseRow = {
             id: i + 1, // id is DrugName-1, DrugName-2, etc.

            Effdt: p.MedStartDate || '',
            NDC: p.NDC || '',
            DrugName: p.DrugName || '',
            GPIName: p.GPIName || '',
            AppQty: p.AppQty ?? '',
            Units: p.Units ?? '',
            DispQty: p?.['Disp Qty'] ?? '',
            CancelQty: p?.['Cancel Qty'] ?? '',
            Reason: p.Reason || '',
            ReimbursmentAmount: p?.['Reimbursment Amount'] ?? '',
            MemberPays: p?.['Member Pays'] ?? '',
          };

          // if (contract === 'HMO Illinois') {
          //   baseRow.Amount = parseFloat(p?.Amount || 0).toFixed(2);
          // } else if (task?.ContractType === 'Premier') {
          //   baseRow['Reimbursment Amount'] = parseFloat(p?.['Reimbursment Amount'] || 0).toFixed(2);
          // }
          console.log('baseRow', baseRow);
          return baseRow;
        });

        setGridRows(rows);

        const total = contract === 'HMO Illinois'
          ? rows.reduce((sum, r) => sum + (parseFloat(r.Amount) || 0), 0)
          : rows.reduce((sum, r) => sum + (parseFloat(r['Reimbursment Amount']) || 0), 0);

        setTotalAmount(total.toFixed(2));
      } catch (error) {
        console.error('Error loading RX details:', error);
        navigate('/error-page');
      }
    };

    if (taskId && contract && pharmacyId && userId) {
      fetchRx();
    }
  }, [taskId, contract, pharmacyId, userId]);

  // document mapping
  
    const document = documents || [];
  
      const documentArray = document.map((doc, index) => ({
  
        id: index,
        documentList: doc.Path,
        bytes: doc.PDFDocument,
      })
    
    )
  
    const documentArraylength = documentArray.length;

    const handleFileDisplay = async (file, bytes) => {
      if (!file) return;
    
      let fileName = typeof file === 'string' ? file : file.name;
      const ext = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
      const docType = 'Prescription';
      const memberID = Array.isArray(taskDetail) ? taskDetail[0]?.MemberID : taskDetail?.MemberID;
    
      const base64 = bytes;
    
      
        try {
          const response = await getOpenOrdersFile(memberID, fileName, contract, docType, base64); // Pass null or omit base64
          if (response) {
            window.open(response, '_blank', 'noopener,noreferrer');
          }
        } catch (error) {
          console.error("Error fetching file:", error);
          toast.error('Failed to fetch file');
        }
        return ;
      
    };
  
    // console.log("Document Array:", {documentArray, documentArraylength});

  const confirmBack = async () => {
    try {
      
  
      toast.success("Order details cleared successfully.");
  
      await unlockRXDetails(contract, userId, taskId, pharmacyId);
  
      toast.success("Task unlocked successfully.");
  
      navigate('/dispensed-order-cigna', {
        state: {
          taskId,
          contract,
          pharmacyId,
          userId,
         
        }
      });
    } catch (err) {
      console.error("Error in handleBack:", err);
      toast.error("An error occurred while navigating back.");
      navigate('/error-page');
    }
  };

  
  const columns = [
    { field: 'Effdt', headerName: 'Med Start Date', width: 100, headerClassName: 'pink-header',  sortable: false },
    { field: 'NDC', headerName: 'NDC', width: 120, headerClassName: 'pink-header', sortable: false },
{ field: 'DrugName', headerName: 'Drug Name', width: 200, headerClassName: 'pink-header', sortable: false,
      renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  ),
     },
    { field: 'GPIName', headerName: 'GPI Name', width: 200, headerClassName: 'pink-header', sortable: false, 
      renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  ),
     },    { field: 'AppQty', headerName: 'App Qty', width: 80, headerClassName: 'pink-header', sortable: false },
    { field: 'Units', headerName: 'Units', width: 80, headerClassName: 'pink-header', sortable: false },
    { field: 'DispQty', headerName: 'Disp Qty', width: 80, headerClassName: 'pink-header', sortable: false },
    { field: 'CancelQty', headerName: 'Cancel Qty', width: 80, headerClassName: 'pink-header', sortable: false },
    { field: 'Reason', headerName: 'Reason', width: 115, headerClassName: 'pink-header', sortable: false },
     { field: 'MemberPays', headerName: 'Member Pays', width: 110, headerClassName: 'pink-header', sortable: false },
    { field: 'ReimbursmentAmount', headerName: 'Reimbursment Amount', width: 145, headerClassName: 'pink-header', sortable: false },
   
    
  ];

  // if (contract === 'HMO Illinois') {
  //   columns.push({ field: 'Amount', headerName: 'Amount', width: 100, headerClassName: 'pink-header' });
  // } else if (taskDetail?.ContractType === 'Premier') {
  //   columns.push({ field: 'Reimbursment Amount', headerName: 'Reimbursment Amount', width: 100, headerClassName: 'pink-header' });
  // }

  if (!taskDetail) {
    return (
      <div>
        <MenuBar />
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
          <CircularProgress sx={{ color: '#ec008c' }} />
          <span style={{ marginTop: '16px', color: '#ec008c', fontSize: '16px', fontWeight: 500 }}>
            Your request is being processed...
          </span>
        </Box>
      </div>
    );
  }

  return (
    <>
    <div>
      <Toaster position="top-right" />
      
        <MenuBar />
        <div className='top-page-option'>
          <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center' }}>
            <a href="#/dispensed-order-cigna" style={{ textDecoration: 'none', color: '#ec088c', display: 'inline-flex', alignItems: 'center' }}
            onClick={async () => {
                                      try {
                                        const user = JSON.parse(localStorage.getItem('user'));
                                        const userId = user?.userId;
                                        const pharmacyId = user?.pharmacyId;
                                        if (!userId || !pharmacyId || !taskId || !contract) {
                                          toast.error('Missing required data for unlocking.');
                                          return;
                                        }
                                        const result = await unlockRXDetails(contract, userId, taskId, pharmacyId);
                        
                                        if (result.success) {
                                          toast.success('Task unlocked successfully');
                                        } else {
                                          toast.error(result?.Message || 'Failed to unlock task');
                                        }
                                      } catch (err) {
                                        console.error('Unlock error:', err);
                                        toast.error('An error occurred while unlocking');
                                      }
                                    }}
            >
              <ChevronLeft color='#ec088c' size={18} />
              <span style={{ marginLeft: '5px' }}>Back</span>
            </a>
          </div>
          <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
             <span>Dispensed Orders</span>
                <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px' }} />
                 <span>Dispensed Orders - Cigna</span>
               <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px' }}/>
              <span>Claims Info</span>
            
          </div>
        </div>

        <div className="outer-box" style={{
          background: '#fff',
          padding: '0px',
          borderRadius: '10px',
          marginLeft: '100px',
          marginRight: '100px',
          textAlign: 'left', // force left alignment for all children
          alignItems: 'flex-start', // ensure children align left
          display: 'block' // remove any flex centering
        }}>

        {/* Member Info */}
        <div className="open-order-box" style={{fontFamily: 'segoe ui', textAlign: 'left', alignItems: 'flex-start', display: 'block' }}>

        <div className="sub-section-header" style={{color: '#ec008c', fontWeight: 'bold', marginBottom: '-5px',marginLeft:'25px', fontSize: '18px' }}>Member Info</div>
<br style={{ display: 'none' }} />
<div className="details-grid" style={{
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '18px 32px',
  borderRadius: '10px',
  padding: '18px 24px',
  marginBottom: '-30px',
  alignItems: 'start',
  fontSize: '14px',
  color: '#222',
  fontFamily: 'segoe ui',
  textAlign: 'left',
  justifyItems: 'start',
  width: 'fit-content',
  marginLeft: 0
}}>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '140px', display: 'inline-block', flexShrink: 0 }}>Member ID:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.MemberID}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>Name:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.MemberName}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>DOB:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.DOB ? new Date(taskDetail.DOB).toLocaleDateString() : ''}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '150px', display: 'inline-block', flexShrink: 0 }}>RelationShip:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.RelationShip || 'N/A'}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>Phone:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.CellPhone}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>Email ID:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.EmailID}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '15px', minWidth: '150px', display: 'inline-block', flexShrink: 0 }}>Certified For:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.CertifiedFor}</span>
  </div>
  
</div><br/>





<div style={{ margin: '20px 0', width: '100%', paddingLeft: '20px' }}>
  <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '13px', tableLayout: 'fixed', fontFamily: 'segoe ui' }}>
    <colgroup>
      <col style={{ width: '33.33%' }} />
      <col style={{ width: '33.33%' }} />
      <col style={{ width: '33.33%' }} />
    </colgroup>
    <thead>
      <tr>
        <th style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Provider Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Authorization Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Attachments</th>
      </tr>
    </thead>
    <tbody style={{ fontFamily: 'segoe ui' }}>
      <tr style={{ fontFamily: 'segoe ui', height: '38px' }}>
        <td style={{ borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Provider Name:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.SerProName}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Provider Phone:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.Telephone}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Provider Fax:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.Fax}</span>
          </div>
        </td>
        <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>WIN Auth #:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.AuthNo}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Auth Duration:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail?.['Auth Duration']}</span>
          </div>
          {/* <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Contract:</strong>
            <span style={{ fontSize: '13px', marginLeft: '8px' }}>{rxData[0]?.Contract}</span>
          </div> */}
        </td>
        <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          {documentArray.length > 0 && (
            <div className="attachment-box" style={{ flex: "0 1 300px", textAlign: 'left', paddingTop: '-20px', fontFamily: 'segoe ui',marginTop:'-14px' }}>
              {documentArray.map((doc, index) => {
      const fileUrl = doc.documentList.replaceAll('\\', '/').replaceAll('\\\\', '/');
      const fileName = fileUrl.split('/').pop();
      // const downloadUrl = attachmentUrls[index]; // Not needed for handleFileDisplay
      return (
        <button
          key={doc.id}
          type="button"
          className="attachment-link"
          style={{
            color: 'blue',
            display: 'flex',
            alignItems: 'center',
            marginTop: '10px',
            fontFamily: 'segoe ui',
            fontSize: '14px',
            textDecoration: 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
          onClick={() => handleFileDisplay(doc.documentList, doc.bytes)} // Pass both path and bytes
        >
          <strong style={{ fontSize: '15px', fontFamily: 'segoe ui', marginRight: '4px', textDecoration: 'none' }}>{`Prescription ${index + 1}:`}</strong>
          <span style={{ fontSize: '14px', fontFamily: 'segoe ui', textDecoration: 'underline' }}>{fileName}</span>
        </button>
      );
    })}
              {/* <p className="attachment-note" style={{ fontStyle: 'italic', marginTop: '10px', fontFamily: 'segoe ui', fontSize: '14px' }}>
                *please see .TIFF attachment for "Other Drugs" in this Rx
              </p> */}
            </div>
          )}
        </td>
      </tr>
    </tbody>
  </table>
  {/* New 2-column table below the existing table, same design */}


  <table style={{ marginTop:'30px',borderCollapse: 'collapse', width: '100%', fontSize: '13px', tableLayout: 'fixed', fontFamily: 'segoe ui',padding: '0 5px' }}>
    <colgroup>
      <col style={{ width: '33.3%' }} />
      <col style={{ width: '66.7%' }} />
    </colgroup>
    <thead>
      <tr>
        <th style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '5px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Task Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Task Notes</th>
      </tr>
    </thead>
    <tbody style={{ fontFamily: 'segoe ui' }}>
      <tr style={{ fontFamily: 'segoe ui', height: '38px' }}>
        <td style={{ fontFamily: 'segoe ui' , padding: '6px', }}>
          
           <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Assigned by:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.AssignedBy}</span>
          </div>
           <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Group ID:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.GroupID}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Priority:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.PriorityStatus}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Received:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.ReceivedDate}</span>
          </div>
		   <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Med Start Date:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.SchStartDate}</span>
          </div>
         </td>
      <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "40px",
        maxWidth: "80%",
      }}
    >
      <div
        className="notes-box"
        style={{
          flex: "1 1 300px",
          position: 'relative',
          boxShadow: notesBoxActive ?  '#ec008c' : undefined,
          borderRadius: '8px',
          padding: '4px',
          transition: 'box-shadow 0.2s',
        }}
        onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
        tabIndex={0}
      >
        <textarea
          className="notes-textarea"
          readOnly
          value={taskDetail?.notes || ""}
          style={{
            width: "95%",
            minHeight: "100px",
            padding: "12px",
            fontSize: "13px",
            borderRadius: "25px",
            border: "1px solid rgba(236, 152, 202)",
            resize: "vertical",
            background: 'white',
            outline: 'none',
            color: notesBoxActive ? '#ec008c' : 'black',
            transition: 'color 0.2s',
          }}
          onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
        />
      </div>
    </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div style={{ margin: '5px', width: '100%', paddingLeft: '20px', fontFamily: 'segoe ui' }}>
  <span style={{ marginRight: '20px' }}>
  

<strong><label>CIGNA Medical Auth# : </label></strong>
   

       <input
            type="text"
            name="medicalAuth"
            autoComplete='off'
            value={medicalAuth}
            onChange={(e) => setMedicalAuth(e.target.value)}
            style={{
              width: '10%',
              height: '20px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '10px',
              border: '1px solid rgba(236, 152, 202)',
              marginLeft: '8px', 
              outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          />
    </span>
    </div>

 {/* <div
  style={{
    marginTop: '30px',
    borderCollapse: 'collapse',
    width: '100%',
    fontSize: '13px',
    tableLayout: 'fixed',
    fontFamily: 'segoe ui',
    padding: '0 5px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // center children horizontally
  }}
>
  <h2 style={{fontSize: '18px', color: '#ec008c', textAlign: 'center', marginBottom: '12px', fontWeight: 'bold' }}>
    Task Notes
  </h2>
  <textarea
    className="notes-textarea"
    readOnly
    value={notes || ""}
    style={{
      width: "60%",
      minHeight: "100px",
      padding: "12px",
      fontSize: "13px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      resize: "vertical",
      background: 'white',
      outline: 'none',
      color: notesBoxActive ? '#ec008c' : 'black',
      transition: 'color 0.2s',
    }}
    onFocus={(e) => {
      e.target.style.border = '1px solid #ec008c';
      e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
    }}
    onBlur={(e) => {
      e.target.style.border = '1px solid #ccc';
      e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
    }}
  />
</div> */}

</div>
</div>

        {/* Shipping Info */}
        {/* <div className="open-order-box" style={{ fontFamily: 'segoe ui' }}>
                      <div className="sub-section-header" style={{color: '#ec008c', fontWeight: 'bold', fontSize: '18px' }}>Shipping Info</div><br/>
                      <table className='Shpping-Info-table' style={{ margin: '0 auto', width: '60%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
  <colgroup>
    <col style={{ width: '50%' }} />
    <col style={{ width: '50%' }} />
  </colgroup>
  <tbody>
    <tr>
      <td style={{ fontSize: '15px', textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>     
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Phone :</strong>
          <span style={{ fontSize: '14px', marginLeft: '8px' }}>{shipping?.Phone}</span>
        </div>  
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Shipping Carrier :</strong>
          <input
            style={{
              width: '30%',
              minHeight: '20px',
              marginLeft: '8px',
              padding: '8px',
              fontSize: '14px',
              borderRadius: '14px',
              border: '1px solid rgba(236, 152, 202)',
              color: '#222',
              fontFamily: 'Segoe UI, Arial, sans-serif',
              outline: 'none',
              boxShadow: '0 1px 4px 0 rgba(236,0,140,0.07)'
              
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}value={shippingCarrier}/>
            
           
         
        </div>
      </td>
    </tr>
    <tr>
      <td style={{ textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>     
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Fax :</strong>
          <span style={{ fontSize: '14px', marginLeft: '8px' }}>{shipping.Fax || '—'}</span>
        </div>
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>#Tracking :</strong>
          <input
            type="text"
            name="trackingID"
            value={trackingNumber}
            style={{
              width: '30%',
              minHeight: '20px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '14px',
              border: '1px solid rgba(236, 152, 202)',
              marginLeft: '8px',
              outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
        e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          />
        </div>
       
      </td>
    </tr>
    <tr>
      <td style={{ textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Address :</strong>
          <textarea value={shipping?.Address || ''}
            readOnly
            style={{
              width: '80%',
              minHeight: '60px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '20px',
              border: '1px solid rgba(236, 152, 202)',
              resize: 'vertical',
              marginLeft: '8px',
            outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          ></textarea>
        </div>
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '15px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Notes :</strong>
          <textarea name="trackingID"
            style={{
              width: '500px',
              minHeight: '60px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '20px',
              border: '1px solid rgba(236, 152, 202)',
              resize: 'vertical',
              marginLeft: '8px',
           outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }} placeholder='Please enter the Notes'></textarea>
        </div>
      </td>
    </tr>
  </tbody>
</table>

</div> */}

        {/* Prescription Grid */}
        <div style={{ width: '100%', margin: '0 auto' }}>
          <div className="sub-section-header" style={{ color: '#ec008c', fontWeight: 'bold', fontSize: '18px' }}>Prescriptions</div>
          <div style={{ height: 'auto' }}>
            <DataGrid
              rows={gridRows}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              hideFooter
              sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            '& .pink-header': {
              color: '#fff',
              backgroundColor: '#ec008c',
              fontWeight: 'bold',
               whiteSpace: 'normal !important',
  wordBreak: 'breakWord !important',
  overflowWrap: 'breakWord !important',
  lineHeight: '1.3 !important',
  textAlign: 'center', /* Optional: center the header text */
  padding: '8px 2px !important',
            },
             '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5 !important',
              cursor: 'pointer',
            },// Remove blue outline on cell focus
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
      backgroundColor: 'none !important',  
     },
     //'& .MuiDataGrid-row:focus-within': {
    //   backgroundColor: '#f5bcbc !important',
    // },
    // Remove blue outline on column header focus
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none !important',
      boxShadow: 'none !important',
    },
          }}
            />
          </div>

          <div style={{ textAlign: 'right', fontWeight: 'bold', marginTop: '10px', marginBottom: '20px' }}>
            Total Amount: ${totalAmount}
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
            <button className="button-open-order" onClick={confirmBack}>Back</button>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default DispensedCignaOpenOrder;
